/** Fallback when RPC has not loaded yet; matches platform default. */
export const DEFAULT_MIN_TRADE_ZAR = 10;

/** True when amount is explicitly positive but below the minimum (show validation; allow empty field). */
export function isBelowMinTradeZar(amount: number, minZar: number): boolean {
  return amount > 0 && amount < minZar;
}

/**
 * User is exiting their entire LMSR position for this outcome (within float tolerance).
 * Full exits may proceed even if gross integral &lt; min trade (see sell panel).
 */
export function isLmsrFullPositionSell(sellQty: number, ownedShares: number, eps = 1e-6): boolean {
  return ownedShares > 0 && sellQty >= ownedShares - eps;
}

/**
 * Block a sell when LMSR gross integral proceeds are under the floor — only for partial sells.
 * Matches `LMSRSellPanel` / backend expectation: full-position sells are exempt.
 */
export function isLmsrPartialSellBlockedByMinIntegral(
  sellQty: number,
  grossIntegralProceeds: number,
  ownedShares: number,
  minZar: number,
  eps = 1e-6,
): boolean {
  if (sellQty <= 0 || grossIntegralProceeds <= 0) return false;
  if (isLmsrFullPositionSell(sellQty, ownedShares, eps)) return false;
  return grossIntegralProceeds < minZar;
}
